import { useQuery } from "@tanstack/react-query";
import { TableCard } from "ui-components/Layout";
import { ListLayout } from "ui-components/Layout";
import BasicTable from "ui-components/tables/BasicTable";
import { POReceivingColumns } from "./columns";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { getPOReceivingEnquiry } from "services/data.report.service";
import { CSVLink } from "react-csv";
import { Grid } from "@mui/material";
import { CustomDateRangePicker } from "ui-components/CustomInput";
import { Error_, Success, Error } from "ui-components/Alert";
import dayjs from "dayjs";
import { LoadingDialog } from "ui-components/Alert";
import { useTeamValue } from "providers/TeamContext";
import { ExportButton } from "ui-components/Button";
import { EmailButton } from "ui-components/Button";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { ExportDialog } from "ui-components/Alert";

function PoReceivingEnquiry() {
  const { permissions, allowAll } = useTeamValue();
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const date = dayjs(new Date()).format("YYYY-MM-DD");
  const sevenDaysBefore = dayjs(new Date()).subtract(1, "day").format("YYYY-MM-DD");
  const [startDate, setStartDate] = useState(sevenDaysBefore);
  const [endDate, setEndDate] = useState(date);
  const { downloadCsv, isDownloading } = useCsvDownloadHook();
  const exportPermission =
    allowAll ||
    (Boolean(permissions["PO Receiving_Report"]) &&
      permissions["PO Receiving_Report"].findIndex((b) => b === "export") !== -1);
  console.log(exportPermission);
  console.log(permissions);

  const { refetch, isFetching } = useQuery({
    queryKey: ["po-receiving-enquiry", { customerCode }],
    queryFn: () => getPOReceivingEnquiry({ customerCode, startDate, endDate }),
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      setData(data.data.data);
      setFilteredData(data.data.data);
    },
    onError: () => { },
  });
  const customProps = { startDate, setStartDate, endDate, setEndDate };

  const handleFilterRowsChange = (filteredData) => {
    setFilteredData(filteredData);
  };

  const onFetch = () => {
    setAlert(null);
    const valid =
      dayjs(endDate).isSame(dayjs(startDate)) || dayjs(endDate).isAfter(dayjs(startDate));
    if (!valid) {
      setAlert(<Error_ content="Start date cannot greater than end date" onChange={setAlert} />);
      return;
    }
    if (dayjs(date).isBefore(endDate)) {
      setAlert(<Error_ content="End date cannot greater than today date" onChange={setAlert} />);
      return;
    }
    refetch();
  };

  const onSuccess = (data) => {
    setAlert(<Success data={data} onChange={setAlert} />);
  };
  const onError = (data) => {
    setAlert(<Error data={data} onChange={setAlert} />);
  };
  return (
    <ListLayout>
      {isFetching && <LoadingDialog />}
      {isDownloading && <ExportDialog />}
      {alert && <MDBox sx={{ my: 3 }}>{alert}</MDBox>}
      <TableCard sx={{ my: 3 }}>
        <MDBox margin="1rem 0 0 1rem">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <CustomDateRangePicker {...customProps} />
            </Grid>
            <Grid item xs={3}>
              <MDButton
                variant="gradient"
                color="info"
                onClick={() => {
                  onFetch();
                }}
              >
                search
              </MDButton>
              {/* <MDButton sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}>
                <CSVLink style={{ color: "white" }} filename={`POReceiving_`} data={filteredData}>
                  export
                </CSVLink>
              </MDButton> */}
              <MDButton
                sx={{ marginLeft: "1rem" }} variant="gradient" color="info" disabled={!exportPermission}
                onClick={() => {
                  const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_POReceiving`;
                  downloadCsv(filename, filteredData)
                }}
              >
                export
              </MDButton>
              {/* <ExportButton
                variant="gradient"
                color="info"
                sx={{ marginLeft: "1rem" }}
                filename={`POReceiving_`}
                fileData={filteredData}
                disabled={!exportPermission}
              /> */}
            </Grid>
            <Grid item xs={5}>
              <EmailButton
                variant="gradient"
                color="info"
                filename={`${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_POReceiving`}
                fileData={filteredData}
                onSuccess={onSuccess}
                onError={onError}
                customerCode={customerCode}
              />
            </Grid>
          </Grid>
        </MDBox>
        <BasicTable
          data={data}
          columns={POReceivingColumns}
          onFilterRowsChange={handleFilterRowsChange}
        />
      </TableCard>
    </ListLayout>
  );
}

export default PoReceivingEnquiry;
